const transactionStatusOptions: { [key: string]: string } = {
  pending: 'pending',
  'in progress': 'in progress',
  requested: 'requested',
  sent: 'sent',
  successful: 'successful',
  complete: 'Complete',
  failed: 'failed',
  cancelled: 'cancelled',
  'cancellation requested': 'cancellation requested',
  settled: 'settled',
  waiting: 'waiting',
};

export default transactionStatusOptions;
